export default __webpack_public_path__ + "static/media/dummy-image.11ca805d.png";